import { useState, useCallback } from 'react';

/**
 * Custom hook for managing experiment list state.
 *
 * @returns {Object} List state and handlers
 */
export function useExperimentList() {
  const [templateNames, setTemplateNames] = useState({});
  const [statusFilterAnchor, setStatusFilterAnchor] = useState(null);
  const [actionMenuAnchor, setActionMenuAnchor] = useState(null);
  const [selectedExperiment, setSelectedExperiment] = useState(null);

  // Fetch template names for experiments
  const fetchTemplateNames = useCallback(experiments => {
    if (!experiments || !experiments.length) return;

    const templateIds = [...new Set(experiments.map(exp => exp.template_id))];
    const names = {};

    // For now, use a simple fallback approach due to CORS issues
    // TODO: Fix API server CORS configuration
    templateIds.forEach(templateId => {
      names[templateId] = templateId;
    });
    setTemplateNames(names);

    // Attempt to fetch real template names (commented out due to CORS issues)
    /*
    const templatePromises = templateIds.map(async (templateId) => {
      try {
        const template = await apiFetch(`api/v1/templates/${templateId}`);
        return { templateId, name: template?.name || 'Unknown Template' };
      } catch (error) {
        debugError(`Error fetching template ${templateId}:`, error);
        return { templateId, name: 'Template (API Error)' };
      }
    });
    
    try {
      const results = await Promise.all(templatePromises);
      results.forEach(({ templateId, name }) => {
        names[templateId] = name;
      });
      setTemplateNames(names);
    } catch (error) {
      debugError('Error fetching template names:', error);
      templateIds.forEach(templateId => {
        names[templateId] = 'Unknown Template';
      });
      setTemplateNames(names);
    }
    */
  }, []);

  const handleStatusFilterOpen = useCallback(event => {
    setStatusFilterAnchor(event.currentTarget);
  }, []);

  const handleStatusFilterClose = useCallback(() => {
    setStatusFilterAnchor(null);
  }, []);

  const handleActionMenuOpen = useCallback((event, experiment) => {
    event.stopPropagation();
    setActionMenuAnchor(event.currentTarget);
    setSelectedExperiment(experiment);
  }, []);

  const handleActionMenuClose = useCallback(() => {
    setActionMenuAnchor(null);
    setSelectedExperiment(null);
  }, []);

  return {
    templateNames,
    statusFilterAnchor,
    actionMenuAnchor,
    selectedExperiment,
    fetchTemplateNames,
    handleStatusFilterOpen,
    handleStatusFilterClose,
    handleActionMenuOpen,
    handleActionMenuClose,
  };
}
